import React, { useEffect, useState } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";

const AddPlan = () => {
  const token = config.token;
  const { pid, id, planof } = useParams();
  const navigate = useNavigate();

  //-------------------------------------------------- state management --------------------------------------
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([
    {
      price: "",
      promotional_price: "",
      duration: "",
      durationUnit: "days",
    },
  ]);

  const handlePlanChange = (e, i) => {
    setPlans((prevPlans) => {
      const newPlans = [...prevPlans];
      newPlans[i] = {
        ...newPlans[i],
        [e.target.name]: e.target.value,
      };
      return newPlans;
    });
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setPlans([
      {
        price: "",
        promotional_price: "",
        duration: "",
        durationUnit: "days",
      },
    ]);
  };

  //--------------------------------------- functionality for plans  ---------------------------------------
  const handleAddPlanBtn = () => {
    setPlans((oldPlans) => {
      return [
        ...oldPlans,
        {
          price: "",
          promotional_price: "",
          duration: "",
          durationUnit: "days",
        },
      ];
    });
  };
  const handleRemovePlanBtn = (index) => {
    const planlist = [...plans];
    planlist.splice(index, 1);
    setPlans(planlist);
  };

  //------------------------------------- create / update plans and redir to chapter -------------------------------c--u
  const updatePlan = () => {
    try {
      const hasEmptyFields = plans.some(
        (plan) =>
          plan.duration === "" || plan.durationUnit === "" || plan.price === ""
      );
      if (hasEmptyFields) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }

      fetch(
        `${config.host_url}plans${
          pid ? "/" + decodeURIComponent(atob(pid)) : ""
        }${planof === "packageid" ? "?from=1" : ""}`,
        {
          method: `${pid ? "PUT" : "POST"}`,
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify({
            plan_for: plans.map((plan) => plan.duration),
            plan_unit: plans.map((plan) => plan.durationUnit),
            plan_price: plans.map((plan) => plan.price),
            promotional_price: plans.map((plan) => plan.promotional_price),
            [planof]: decodeURIComponent(atob(id)),
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // plan created successfully
            triggerNotification(
              "success",
              `plan${pid ? " updated " : "s created "} successfully.`
            );
            setPlans([
              {
                price: "",
                promotional_price: "",
                duration: "",
                durationUnit: "days",
              },
            ]);
            if (planof === "courseid") {
              navigate(`/viewcourse/${id}`);
            } else if (planof === "chapterid") {
              navigate(`/viewchapter/${id}`);
            } else if (planof === "packageid") {
              navigate(`/viewpackage/${id}`);
            }
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          // Handle fetch error here
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating plan:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the plan."
      );
    }
  };

  // --------------------------------------- Read / Select / Get plan data for update---------------------------------------R
  const getPlanData = async () => {
    setLoading(true);
    try {
      await fetch(
        `${config.host_url}${
          planof === "packageid" ? "plans/" : "chapter/plan/"
        }${decodeURIComponent(atob(pid))}${
          planof === "packageid" ? "?from=1" : ""
        }`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            const responseData = data.data;
            // console.log(data.data);
            setPlans([
              {
                price:
                  planof === "packageid"
                    ? responseData.price
                    : responseData.plan_price,
                duration:
                  planof === "packageid"
                    ? responseData.pkg_plan_for
                    : responseData.plan_for,
                durationUnit:
                  planof === "packageid"
                    ? responseData.pkg_plan_unit
                    : responseData.plan_unit,
                promotional_price:
                  planof === "packageid"
                    ? responseData.promotional_price
                    : responseData.promotional_price,
              },
            ]);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching plan.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (pid !== undefined) {
      getPlanData();
    }
  }, [pid]);

  return (
    <>
      {planof === "chapterid" ? (
        <Breadcrumb
          txt="Manage Chapter"
          subpath={[
            "View Chapters",
            "Chapter Details",
            `${pid ? "Update Plan" : "Add Plan"}`,
          ]}
          url={["/viewchapters", `/viewchapter/${id}`]}
        />
      ) : planof === "courseid" ? (
        <Breadcrumb
          txt="Manage Course"
          subpath={[
            "View Courses",
            "Course Details",
            `${pid ? "Update Plan" : "Add Plan"}`,
          ]}
          url={["/viewcourses", `/viewcourse/${id}`]}
        />
      ) : planof === "packageid" ? (
        <Breadcrumb
          txt="Manage Package"
          subpath={[
            "View Packages",
            "Package Details",
            `${pid ? "Update Plan" : "Add Plan"}`,
          ]}
          url={["/viewpackages", `/viewpackage/${id}`]}
        />
      ) : (
        <Breadcrumb txt="Manage Plan" subpath={["Add Plan"]} />
      )}
      {/* form view */}

      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">{pid ? "Update Plan" : "Add Plan"}</h5>
          </div>
          <div className="card-body">
            {loading ? (
              <Spinner />
            ) : (
              <>
                {plans.map((plan, i) => (
                  <div key={i}>
                    {/* cancel plan */}
                    {i > 0 && (
                      <>
                        <hr className="mt-2 mb-3" />
                        <div
                          className="text-red-600 mb-2  col-sm-2 select-none"
                          onClick={() => handleRemovePlanBtn(i)}
                        >
                          <span className="mdi mdi-close pr-2"></span>
                          Remove Plan
                        </div>
                      </>
                    )}
                    {/*  Duration */}
                    <div className="">
                      <div className="form-floating form-floating-outline mb-4  ">
                        <input
                          type="number"
                          min="1"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Duration"
                          value={plan.duration}
                          name="duration"
                          onChange={(e) => handlePlanChange(e, i)}
                        />
                        <label htmlFor="basic-default-phone">Duration</label>
                      </div>
                    </div>
                    {/* Duration unit */}
                    <div className="">
                      <div className="form-floating form-floating-outline mb-4">
                        <select
                          className="form-select"
                          id="exampleFormControlSelect1"
                          aria-label="Default select example"
                          value={plan.durationUnit}
                          name="durationUnit"
                          onChange={(e) => handlePlanChange(e, i)}
                        >
                          <option value="days">Days</option>
                          <option value="weeks">Weeks</option>
                          <option value="months">Months</option>
                        </select>
                        <label htmlFor="exampleFormControlSelect1">
                          Duration Unit
                        </label>
                      </div>
                    </div>
                    {/* Price */}
                    <div className="">
                      <div className="form-floating form-floating-outline mb-4 ">
                        <input
                          type="number"
                          min="1"
                          id="price"
                          className="form-control phone-mask"
                          placeholder="Price"
                          value={plan.price}
                          name="price"
                          onChange={(e) => handlePlanChange(e, i)}
                        />
                        <label htmlFor="price">Price</label>
                      </div>
                    </div>
                    {/* Promotional Price */}
                    <div className="">
                      <div className="form-floating form-floating-outline mb-4 ">
                        <input
                          type="number"
                          min="1"
                          id="promotionalpr"
                          className="form-control phone-mask"
                          placeholder="Promotional Price"
                          value={plan.promotional_price}
                          name="promotional_price"
                          onChange={(e) => handlePlanChange(e, i)}
                        />
                        <label htmlFor="promotionalpr">Promotional Price</label>
                      </div>
                    </div>
                  </div>
                ))}

                {/* submit | calcel */}
                <div className="mt-3 justify-content-end">
                  {/* submit */}
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={updatePlan}
                  >
                    {pid ? "Update" : "Submit"}
                  </button>
                  {/* clear | calcel */}
                  <button
                    type="button"
                    className="btn ml-2 btn-secondary"
                    onClick={clearForm}
                  >
                    Cancel
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPlan;
